import { Box, Flex, Text } from "@chakra-ui/layout";
import { Container } from "./styles";
import moment from "moment";
import { Button } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import OutlineButton from "ui/components/Button/OutlineButton";
import { HistoricoCobrancaItemResponse } from "core/features/cobranca/typings/index";

interface ConteudoHistoricoDeCobrancaProps {
  data: HistoricoCobrancaItemResponse;
  onOpenAnotacoes?: () => any;
  onEdit?: () => any;
}

function ConteudoHistoricoDeCobranca({
  data,
  onOpenAnotacoes,
  onEdit,
}: ConteudoHistoricoDeCobrancaProps) {
  return (
    <Container>
      <Flex mb={"8px"}>
        <Box>
          <Text
            fontSize="16px"
            color={"#8291A9"}
            fontWeight={"500"}
            fontStyle={"italic"}
            mr={"32px"}
          >
            {data.hora
              ? `${moment(data.data).format("DD/MM/YYYY")} às ${moment(
                  data.hora,
                  "HH:mm:ss"
                ).format("HH:mm")}`
              : moment(data.data).format("DD/MM/YYYY")}
          </Text>
          {data.proximoAgendamento?.data ? (
            <Text mt={0} fontSize="12px">
              Retornar contato
            </Text>
          ) : null}
        </Box>

        <Box
          rounded="14px"
          px="12px"
          py="2px"
          borderWidth="1px"
          borderColor="#c4c4c4"
          height="max-content"
        >
          <Text
            fontSize="12px"
            color={"#C4C4C4"}
            fontWeight={"500"}
            fontStyle={"italic"}
          >
            {data.tipoContato.nome}
          </Text>
        </Box>

        <OutlineButton onClick={onEdit} ml="auto">
          Editar
        </OutlineButton>
      </Flex>
      <Box fontSize={"12px"} mb={"8px"}>
        <Text m={0} color={"#8291A9"}>
          MOTIVO DA INADIMPLÊNCIA:
        </Text>
        <Text m={0}>{data.motivoInadimplencia?.nome}</Text>
      </Box>

      {data.proximoAgendamento ? (
        <Box fontSize={"12px"} mb={"8px"}>
          <Text m={0} color={"#8291A9"}>
            NOVO CONTATO AGENDADO PARA:
          </Text>
          <Text m={0}>{`${moment(data.proximoAgendamento.data).format(
            "DD/MM/YYYY"
          )} às ${moment(data.proximoAgendamento.hora, "HH:mm:ss").format(
            "HH:mm"
          )}`}</Text>
        </Box>
      ) : null}

      {data.observacao ? (
        <Button
          mt={4}
          onClick={onOpenAnotacoes}
          variant="link"
          w="fit-content"
          fontSize="sm"
          fontWeight="500"
          color={colors.blue}
        >
          Ver anotações
        </Button>
      ) : null}
    </Container>
  );
}

export default ConteudoHistoricoDeCobranca;
